// src/components/Navbar.js
import { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo/LogoBlancoFX.png';

const CustomNavbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!isHomePage) return;

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  const navStyle = {
    transition: 'background-color 0.3s ease, padding 0.3s ease',
    backgroundColor: isHomePage ? (scrolled ? '#16125A' : 'transparent') : '#16125A',
    padding: '0.5rem 0',
  };

  return (
    <Navbar expand="lg" fixed="top" style={navStyle} className="custom-navbar">
      <Container>
        <Navbar.Brand as={Link} to="/">
      
    <img src={logo} alt="Logo" height="100" style={{ maxHeight: '100px' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="navbar-nav" style={{ backgroundColor: '#fff' }} />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link
              as={Link}
              to="/"
              className="mx-3 nav-hover fs-4"
            >
              Inicio
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/live"
              className="mx-3 nav-hover fs-4"
            >
              En Vivo
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/catalogo"
              className="mx-3 nav-hover fs-4"
            >
              Catálogo
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
